module.exports = __webpack_public_path__ + "static/media/SIDRA AL MUSA.08477f48.png";